import styled from 'styled-components';

export const QuestionListContainer = styled.section`
  margin-top: 40px;
  overflow: hidden;
  border-radius: 10px;
`;

export const QuestionListItem = styled.li`
  color: ${({ theme }) => theme.textDark};
  transition: color cubic-bezier(0.4, 0, 0.2, 1) 300ms;
  border-style: solid;
  border-width: 0px;
  font-weight: bold;
  border-color: ${({ theme }) => theme.backgroundLighter};
  text-align: left;

  a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    gap: 15px;
    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }

  svg {
    color: ${({ theme }) => theme.primary};
  }
`;

export const QuestionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  & > * + * {
    border-top-width: 1px;
  }

  & > :first-child {
    border-top-width: 0;
  }
`;
